import { t } from "i18next";
import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { getMisc, getOrganizationsData, updateOrganization } from "../../apiclients/streamsapi_bridge";
import DeleteOrgORPool from "../../views/popups/orggroups/deleteOrg";
import EditOrg from "../../views/popups/orggroups/EditOrg";
import NewOrg from "../../views/popups/orggroups/NewOrg";
import PopupLoader from "../../views/popups/PopupLoader";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";

export default function Organizations(isActive) {

    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);

    const [addOrg, setAddOrg] = useState(false);
    const addOrgOpen = () => setAddOrg(!addOrg);

    const [orgId, setOrgId] = useState(-1);
    const [deleteOrgFlag, setDeleteOrgFlag] = useState(false);
    const toggleDelOrg = () => setDeleteOrgFlag(!deleteOrgFlag);

    const [listOrgData, setListOrgData] = useState([]);

    const [editOrgFlag, setEditOrgFlag] = useState(false);
    const toggleEditOrgFlag = () => setEditOrgFlag(!editOrgFlag);

    const [selectedOrgInfo, setSelectedOrgInfo] = useState([]);

    const [miscOrgInfo, setMiscOrgInfo] = useState({});

    const [resOrgInfo, setResOrgInfo] = useState({});
    const [editResponse, setEditResponse] = useState(false);

    const [currentOrg, setcurrentOrg] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [orgName, setOrgName] = useState('');

    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [rowdata, setRowData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
        useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,isActive)
  
    async function onRowClick(e) {
        await getMiscOrgInfo();
        toggleEditOrgFlag();
        setSelectedOrgInfo(e.orgInfo ?? {});
        setOrgName(e.orgInfo?.org_name ?? "");
    }




    async function getMiscOrgInfo() {
        try {
            const apiResponse = await getMisc(JSON.parse(sessionStorage.getItem("admin_session")).siteid, { misc: ["org_info"] });
            if (!apiResponse.json) {
                const message = `An error has occured: ${apiResponse.statusText}`;
                return;
            }
            const apiInfo = await apiResponse.json();
            setMiscOrgInfo(apiInfo?.misc?.org_info);


        } catch (e) {
            console.log(`Org Info not available:${e}`);
        }
    }

    async function getAllOrgData() {
        try {
            setIsloading(true);
            const response = await getOrganizationsData(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.ORGANIZATIONS_SUBLINK
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            const allOrgGrpData = await response.json();
            console.log(`Org get all allOrgGrpData ${JSON.stringify(allOrgGrpData)}`);
            if (response.status == 200) {
                setListOrgData(allOrgGrpData.all_orgs ?? []);
            } else {
                setInternalError(true);
            }

        } catch (error) {
            console.log(`Unable to process org req:${error}`);
            setInternalError(true);
        }
    }

    // updating the edit Organiztion information.
    async function updateEditOrganization(resOrgInfo = {}, selOrgId, selOrgName) {
        try {
            if (Object.keys(resOrgInfo).length > 0) {
                let updateJSON = {
                    reqid: 108,
                    orgid: selOrgId,
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                };

                if (selOrgName != resOrgInfo.update_org_name) {
                    updateJSON.org_name = resOrgInfo.update_org_name
                }
                if (resOrgInfo.added_pools?.length > 0) {
                    updateJSON.add_pools = resOrgInfo.added_pools?.map((poolObj) => poolObj.pool_id);
                }
                if (resOrgInfo.removed_pools?.length > 0) {
                    updateJSON.remove_pools = resOrgInfo.removed_pools?.map((poolObj) => poolObj.pool_id);
                }
                setIsloading(true);
                // sending update request.
                let apiResponse = await updateOrganization(updateJSON);
                setTimeout(() => { setIsloading(false) }, 1000);
                let apiData = await apiResponse.json();

                if (apiResponse.status == 200) {

                    localStorage.setItem("s_message", apiData.message);
                    window.location.href = "/orggroupslandingpage";
                    setEditOrgFlag(false);
                }
                else if (apiData?.message?.errors) {

                    apiData.message.errors.forEach((err) => {
                        if (err.param_name === "org_name")
                            setErrorMessage(err.message);
                    });
                }

                else {
                    setInternalError(true);
                    setEditOrgFlag(false);
                }
            }



        } catch (error) {
            console.log(`Unable to update the organization informaiton : ${error}`);
        }
    }

    useEffect(() => {
        if (editResponse == true) {
            updateEditOrganization(resOrgInfo, selectedOrgInfo.orgid, selectedOrgInfo.org_name);
            setEditResponse(false);
        }

    }, [editResponse]);

    useEffect(() => {
        // fetching the organizations information
        getAllOrgData();
    }, []);

    function deleteOrg(event, ele) {
        event.preventDefault();
        event.stopPropagation();
        setOrgId(ele.orgid);
        toggleDelOrg();
        setcurrentOrg(ele)


    }


    const actionData = {
        columns: [
            { label: 'Org Name', field: 'org_name', sort: true },
            // { label: "", field: "defaultOrg", sort: false, colSpan: 1 },
            { label: 'Org Pool(s)', field: 'orgPool' },
            { label: 'Remove', field: 'delete', sort: false },
        ],
        rows: []
    }
    useEffect(() => { 
    actionData.rows = listOrgData.map((ele) => ({
        org_name: ele.org_name + (ele.org_name && ele.org_name === "Default Org" ? " (Default)" : ""),
        // defaultOrg: (
        //     <div>
        //         {ele.org_name && ele.org_name === "Default Org" && (
        //             <>
        //             <div className="d-flex">
        //                 <div className="px-2 ms-2 border border-1 rounded-pill border-success text-center">
        //                     <span className="small text-success">Primary</span>
        //                 </div>
        //             </div>
        //             </>
        //         )}

        //     </div>
        // ),
        orgid: ele.orgid,
        orgPool: ele.org_pools?.map(e => e.pool_name).join(",") ?? '',
        orgInfo: ele,
        delete: (
            <>
                {!(ele.org_name && ele.org_name === "Default Org") && (
                    <div className="d-flex align-items-center ms-2">
                        <div className="custom-hover-bg p-1 ms-2 cursor-pointer deleteToolTip"
                            onClick={(e) => deleteOrg(e, ele)}
                        >
                            <MDBIcon fas icon="times" color="primary" className="px-2 fs-5" />
                        </div>
                    </div>
                )}
            </>
        )

    }));
    setRowData(actionData.rows);
    setFilteredRows(actionData.rows)
    setDataLoaded(true)

},[listOrgData,isActive])


    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowdata, searchValue, UIConstant.ORG_LANDING);

        setFilteredRows(filteredUsers);
    };




    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('.usersData-Table td');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (trimmed && td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };

        // Initial patch
        patchTitles();

        const table = document.querySelector('.usersData-Table');

        if (!table) return;

        const observer = new MutationObserver(() => {
            patchTitles();
        });

        observer.observe(table, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);





    return (
        <>
            <div className="OrganizationsDataTable OrgPoolDataTable">
                <div className="actionbar">
                    <MDBBtn onClick={addOrgOpen}>
                        New Org
                    </MDBBtn>
                </div>
                <div className='mb-2 mt-2 position-relative w-auto'>
                    <MDBInput ref={searchRef} label="Search" value={searchValue}  onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <MDBDatatable key={searchValue}
                hover
                data={{
                    ...actionData,
                    rows: filteredRows, // Use filtered rows here
                  }}
                sortField="Org Name" onRowClick={(e) => onRowClick(e)} entries={50} />
            </div>

            {editOrgFlag && (
                <PopupLoader
                    title={"Edit Organization"}
                    content={
                        <EditOrg
                            onClose={toggleEditOrgFlag}
                            accPools={miscOrgInfo?.free_pools ?? []}
                            existingPools={selectedOrgInfo.org_pools ?? []}
                            setResOrgInfo={setResOrgInfo}
                            setAddOPFlag={setEditResponse}
                            errorMessage={errorMessage}
                            setErrorMessage={setErrorMessage}
                            orgName={orgName}
                            setOrgName={setOrgName}
                        />
                    }
                    onClose={(e) => { setErrorMessage(""); toggleEditOrgFlag(); }}
                />

            )
            }


            {addOrg && addOrg == true && (

                <PopupLoader
                    title={"Add New Organizations"}
                    content={
                        <NewOrg
                            onClose={addOrgOpen}
                        />
                    }
                    onClose={addOrgOpen}
                />
            )
            }

            {deleteOrgFlag && (

                <PopupLoader
                    title={t("Remove_Org")}
                    content={
                        <DeleteOrgORPool
                            id={orgId}
                            delType={1}
                            title={t("Remove_Org")}
                            onClose={toggleDelOrg}
                            orgData={currentOrg}
                        />
                    }
                    onClose={toggleDelOrg}
                />
            )
            }

            {
                isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )
            }

            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="top-center"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}

        </>
    );


}